var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phases"},[_c('at-table',{attrs:{"columns":_vm.columns,"data":_vm.rows}}),_vm._v(" "),(this.showControls)?_c('at-button',{staticClass:"phases__add-btn",attrs:{"type":"primary"},on:{"click":_vm.addPhase}},[_vm._v(_vm._s(_vm.$t('field.add_phase')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }